/* eslint-disable no-nested-ternary */
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import getTripStatus from "../../../Utils/getTripStatus";
import EditAndDeleteDropDown from "../EditAndDeleteDropDown";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import FarmerBadge from "./FarmerBadge";
import { TRIP_STATUS } from "../Data/TripConstants";
import StarIcon from "../../../Common/Svgs/StarIcon";

const TripDetailsHeader = () => {
  const { stopId, farmerId } = useParams();
  const navigate = useNavigate();

  const {
    currentTrip,
    currentStop,
    currentFarmer,
    overallSummaryForTrip,
    stopSummary,
  } = useSelector((state) => state.trips);

  const onHeaderClick = () => {
    navigate(-1);
  };

  const hasPendingReceipt =
    !currentStop.isOrigin &&
    stopSummary.some(
      (item) =>
        item?.activities?.[0]?.type === 2 &&
        item?.activities?.[0]?.metaData?.receiptStatus === 0
    );

  const filtered = stopSummary.filter(
    (item) =>
      item?.activities?.[0]?.type === 2 && item?.activities?.[0]?.metaData
  );

  const allReceiptsVerified =
    !currentStop.isOrigin &&
    filtered.length &&
    filtered.every((item) => item.activities[0].metaData.receiptStatus === 1);

  const getHeader = () => {
    if (farmerId) {
      return (
        <div className="flex items-center">
          <button
            type="button"
            className="flex items-center gap-x-2"
            onClick={onHeaderClick}
          >
            <ChevronIcon className="w-5 h-5 stroke-dark-gray rotate-180" />
            <p className="font-poppins text-base font-medium">
              {currentFarmer.name}
            </p>
          </button>

          {currentFarmer.isNewFarmer ? (
            <div className="ml-2">
              <FarmerBadge type={1} text="New Entry" />
            </div>
          ) : currentFarmer?.farmerStop ? (
            <div className="ml-2">
              <FarmerBadge
                type={2}
                text={`Farmer originally from Stop ${currentFarmer.farmerStopName}`}
              />
            </div>
          ) : null}
        </div>
      );
    }
    if (stopId) {
      return (
        <div className="flex items-start gap-x-2">
          <button
            type="button"
            className="flex items-center gap-x-2"
            onClick={onHeaderClick}
          >
            <ChevronIcon className="w-5 h-5 stroke-dark-gray rotate-180" />
            <p className="font-poppins text-base font-medium capitalize">
              {currentStop?.stopName || "--"}
            </p>
            <div className="bg-primary-10 py-1 px-2 max-w-max rounded font-poppins text-xs font-medium text-primary">
              Stop {currentStop?.index}
            </div>
          </button>
          {hasPendingReceipt === true && (
            <p
              className="
                bg-alert-red
               py-1 px-2 max-w-max rounded font-poppins text-xs font-medium text-background-white"
            >
              Verification Pending
            </p>
          )}
          {allReceiptsVerified === true && (
            <p className="bg-primary py-1 px-2 max-w-max rounded font-poppins text-xs font-medium text-background-white">
              Receipts Verified
            </p>
          )}
        </div>
      );
    }

    return (
      <div className="flex items-center gap-x-3">
        <p className="text-base font-medium font-poppins text-new-black">
          Overview
        </p>

        {currentTrip?.statusId === TRIP_STATUS.COMPLETED &&
        overallSummaryForTrip?.forceEnd ? (
          <div className="py-0.5 px-2 rounded max-w-max bg-yellow-dark">
            <p className="font-poppins text-xs font-normal text-background-white">
              Trip completed by {overallSummaryForTrip?.forceEndFirstName}{" "}
              {overallSummaryForTrip?.forceEndLastName}
            </p>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className="flex items-center justify-between px-6 border-b border-r bg-background-white border-light-grey h-14">
      {getHeader()}
      <div className="flex items-center justify-end gap-x-3">
        <div className="flex items-center gap-x-3">
          {currentTrip?.driverRating && (
            <div className="bg-background flex gap-x-1 px-2 py-1 rounded-4">
              {[1, 2, 3, 4].map((num) => (
                <button key={num} type="button" className="focus:outline-none">
                  <StarIcon
                    size={18}
                    fill={num <= currentTrip?.driverRating ? "#FFD700" : "none"}
                    stroke={
                      num <= currentTrip?.driverRating ? "none" : "#525252"
                    }
                    strokeWidth={1.5}
                  />
                </button>
              ))}
            </div>
          )}
          {getTripStatus(currentTrip?.statusId, currentTrip)}

          <EditAndDeleteDropDown
            tripId={currentTrip.id}
            detail={currentTrip}
            listingPage={false}
          />
        </div>
      </div>
    </div>
  );
};

export default TripDetailsHeader;
